export default __webpack_public_path__ + "static/media/back.97173f1a.svg";